interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "SOS";
};

const SOS: Currency = Object.freeze({
  "displayName": "Somali Shilling",
  "numericCode": 706,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "SOS",
  "symbol": "Sh"
});

export { SOS };
